// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"db10de6f","167":"a837631c","768":"fcf8aeba","772":"1579e826","843":"fcf8aeba","982":"055fc64f"}[chunkId] + ".chunk.css";
};